<template>
  <!-- REMOVE V-APP WHEN THIS IS A SUB PAGE -->
  <v-app> 
    <div
      class="text-center"
      style="min-height: 100%; background-color: #ffffff;"
    >
      <div
        class="hero-bg"
        style="margin-bottom: -10vw; height: 300px"
      >
        <h1>ABOUT </h1>
      </div>
      <tcc-edge
        style="width: 100%"
        right-color="#f4f4f4"
        left-color="#ffd700"
      />
      <v-container
        fluid
        style="background-color: #f4f4f4;"
      >
        <v-row
          justify="center"
          style="min-height: 100vh;"
          class="py-12"
        >
          <v-col />
        </v-row>
      </v-container>

      <tcc-edge
        right-color="#f4f4f4"
        left-color="#ffd700"
        is-footer
      />
      <div
        class="hero-bg"
        style="margin-top: -6vw; min-height: 300px"
      />
      <tcc-foot />
    </div>
  </v-app>
</template>

<script>
import tccEdge from "@/components/tccEdge.vue";
import tccFoot from "@/components/tccFooter.vue";

export default {
    name: 'About',
    components: {
        tccEdge,
        tccFoot
    },
    data() {
        return {
            customerSignedIn: false,
            customer: null,
        };
    },
    watch: {
    },
    async mounted() {
        console.log( "ABOUT UNMOUNTED" );

    },
    destroyed(){
        console.log( "ABOUT UNMOUNTED" );
    },
    methods: {

    }


};
</script>

<style scoped>

.hero-bg {
  width: 100%;
  /* height: 35vw;  */
  /* min-height: 35vh; */
  background: url( '/img/tcc-background.png' ) repeat fixed top center;
  /* background-size: cover; */
}

</style>

